import React from "react";

const Navbar = () => {
  return (
    <nav className="flex justify-between items-center py-2 px-10 bg-customWhite">
      <div className="flex items-center">
        <a href="https://www.automateaccounts.com/">
          <img
            src="https://cdn.prod.website-files.com/65e7f17ed06050fdd972fa15/65e7f6be5598890c6288f83c_AA%20logo%20(transparent%20background)%20(white)-p-500.png"
            alt="Ultimate Accounts Logo"
            className="h-16 w-22"
          />
        </a>
      </div>

      <div>
        <button className="bg-customRed text-customWhite px-3 py-3 rounded-full">
          <a
            href="https://www.automateaccounts.com/book-a-free-consultation"
            target="_blank"
            rel="noopener noreferrer"
          >
            Book a Call
          </a>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
